<template>
  <div class="login-form-home sign-up-form text-left" >
    <div class="login-form-wrapper">
      <div class="bp-logo">
          <img src="@/assets/images/logos/BP.png" alt="logo">
          <p class="app-name">PLAYER</p>
      </div>

      <div class="wrong-page text-align-left" v-if="!linkIsValid && pageLoaded && !redeemedLink">
        {{ $t('OUTER_PAGES.common.notValid')}}
      </div>

      <div class="wrong-page text-align-left" v-if="notFound">
        {{ $t('OUTER_PAGES.common.notFound')}}
      </div>

      <div v-if="linkIsValid & pageLoaded && !redeemedLink" class="text-align-left">
        <i18n path="OUTER_PAGES.organizationInvite.inviteAccepted">
          <router-link slot="here" class="link underline" :to="{ name: 'Login' }">{{ $t('OUTER_PAGES.organizationInvite.here')}}</router-link>
        </i18n>
      </div>
      <div v-if="redeemedLink & pageLoaded" class="text-align-left">
        <i18n path="OUTER_PAGES.organizationInvite.redeemedLink">
          <router-link slot="loginPage" class="link underline" :to="{ name: 'Login' }">{{ $t('OUTER_PAGES.variables.loginPage')}}</router-link>
        </i18n>
      </div>
    </div>
  </div>
</template>

<script>
import { ORGANIZATION_INVITE_URL } from '@/constants/ApiConstants';
import ApiService from '@/common/api.service';
import { mapActions } from 'vuex'
import { LOGOUT } from '@/store/action.types';
import STATUS_CODES from '@/common/statusCodes'

export default {
  name: 'OrganizationInvite',
  data () {
    return {
      linkIsValid: false,
      pageLoaded: false,
      redeemedLink: false,
      notFound : false
    }
  },
  computed: {
    confirmationToken: {
      get () {
        return this.$route.params.token;
      }
    }
  },
  mounted () {
    ApiService.put(`${ORGANIZATION_INVITE_URL.replace(':token', this.confirmationToken)}`)
      .then(response => {
        if(response.status.code === STATUS_CODES.BP_412) {
          this.pageLoaded = true
          this.redeemedLink = true
        } else if (response.status.code === STATUS_CODES.BP_404){
          this.notFound = true
        } else if (response.status.code === STATUS_CODES.BP_405){
          this.pageLoaded = true
        } else {
          this.pageLoaded = true;
          this.linkIsValid = true;
          this.logoutAction();
        }
        
      })
      .catch((error) => {
        this.pageLoaded = true
      })
  },
  methods: {
    ...mapActions({
      logoutAction: LOGOUT
    }),
  }
}
</script>
